module.exports = __webpack_public_path__ + "static/media/9D.6467993b.svg";